define.alias("ember-cli-string-helpers/helpers/html-safe", "settings/helpers/html-safe");